import React from "react";
import { FiArrowUp, FiArrowDown, FiMinus } from "react-icons/fi";

export default function EquityFocusCard({
    title = "Equity Focus - Rural / Urban / Tribal Gap",
    sections = [], // [{ subHeading, categories: [] }]
    height = "auto",
}) {
    const getTrendIcon = (t) => {
        if (t > 0) return <FiArrowUp className="text-green-600" />;
        if (t < 0) return <FiArrowDown className="text-red-600" />;
        return <FiMinus className="text-slate-500" />;
    };

    return (
        <div
            className="bg-white rounded-2xl px-3 py-3 shadow-sm"
            style={{ height }}
        >
            {/* Main Heading */}
            <h3 className="text-sm font-semibold text-slate-800 mb-3">
                {title}
            </h3>

            {/* Sections */}
            <div className="space-y-1">
                {sections.map((sec, index) => (
                    <div key={index} className="pb-4 border-b last:border-b-0">
                        {/* Sub Heading */}
                        <h4 className="text-sm font-semibold text-slate-700 mb-3">
                            {sec.subHeading}
                        </h4>

                        {/* Category Bars */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {sec.categories.map((item, idx) => (
                                <div key={idx} className="w-full">

                                    {/* Label Row */}
                                    <div className="flex justify-between items-center mb-1">
                                        <span className="text-xs text-slate-600 font-medium">
                                            {item.label}
                                        </span>

                                        <div className="flex items-center gap-1">
                                            <span className="text-xs font-semibold text-slate-800">
                                                {item.value}%
                                            </span>

                                            {/* Trend */}
                                            {item.trend !== undefined && (
                                                <span className="flex items-center text-xs">
                                                    {getTrendIcon(item.trend)}
                                                    <span
                                                        className={
                                                            item.trend > 0
                                                                ? "text-green-600"
                                                                : item.trend < 0
                                                                    ? "text-red-600"
                                                                    : "text-slate-500"
                                                        }
                                                    >
                                                        {item.trend > 0 ? `+${item.trend}` : item.trend}
                                                    </span>
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {/* Progress Bar */}
                                    <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden">
                                        <div
                                            className="h-full rounded-full transition-all"
                                            style={{
                                                width: `${item.value}%`,
                                                backgroundColor: item.color,
                                            }}
                                        ></div>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
